<!-- command-bar -->
<div class="cbar">
  <div class="ms-CommandBar">
    <div class="ms-CommandBar-mainArea">
      <div class="ms-CommandButton">
        <button
          (click)="abrirModalCrear()"
          class="ms-CommandButton-button"
          type="button"
        >
          <span class="ms-CommandButton-icon ms-fontColor-themePrimary"
            ><i class="ms-Icon ms-Icon--CalculatorAddition"></i
          ></span>
          <span class="ms-CommandButton-label">Nuevo</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="pageContent">
  <div class="pageTitle">
    <h2>Conectores</h2>
  </div>
  <app-data-table
    tableId="datatableConectores"
    [serverSide]="true"
    [serverData]="getDataTableConectores"
    [columns]="columnas"
    (loadedGrid)="gridLoaded($event)"
    (custom)="customClick($event)"
    [buttonsOptions]="dtOptButtons"
  ></app-data-table>
</div>

<!-- Nuevo/Editar -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader create-conectores" appPreventOutsideClick>
    <div id="dialogCreateEdit" class="ms-Dialog-title">Crear Conector</div>
    <form
      [formGroup]="conectorForm"
      (ngSubmit)="crearEditarConector()"
      name="conectorForm"
    >
      <div class="ms-Dialog-content input-grid form-group">
        <div>
          <app-text-box
            [frm]="conectorForm"
            formControlName="Nombre"
            type="text"
            [required]="true"
            label="Nombre"
          ></app-text-box>
        </div>
        <div>
          <app-text-area
            [frm]="conectorForm"
            formControlName="Descripcion"
            [required]="true"
            label="Descripción"
            rows="3"
          ></app-text-area>
        </div>
        <div>
          <div class="ms-Dropdown dropdown" tabindex="0">
            <label class="ms-Label is-required" for="IdTipoConector"> Tipo de Conector </label>
            <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"></i>
            <select
              class="form-control"
              id="IdTipoConector"
              formControlName="IdTipoConector"
            >
              <option value="" disabled selected>Seleccione...</option>
              <option *ngFor="let tipo of tipoConectoresList" [value]="tipo.Id">
                {{ tipo.Nombre }}
              </option>
            </select>
          </div>
          <p
            style="color: brown"
            *ngIf="
              conectorForm.controls.IdTipoConector.invalid &&
              (conectorForm.controls.IdTipoConector.dirty ||
                conectorForm.controls.IdTipoConector.touched)
            "
          >
            El tipo de conector es requerido
          </p>
        </div>
        <div>
          <div class="ms-Dropdown dropdown" tabindex="0">
            <label class="ms-Label is-required" for="Estado"> Estado </label>
            <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"></i>
            <select
              class="form-control"
              id="estadoConector"
              [(ngModel)]="conectorObj.Estado"
              formControlName="Estado"
            >
              <option disabled>Seleccione...</option>
              <option value="1">Diseño</option>
              <option value="2">Pruebas</option>
              <option value="3">Produccion</option>
            </select>
          </div>
          <p
            style="color: brown"
            *ngIf="
              conectorForm.controls.Estado.invalid &&
              (conectorForm.controls.Estado.dirty ||
                conectorForm.controls.Estado.touched)
            "
          >
            El estado es requerido
          </p>
        </div>
        <div>
          <app-text-box
            [frm]="conectorForm"
            formControlName="Version"
            type="number"
            [required]="true"
            label="Versión"
            (input)="onInputChange($event)"
          ></app-text-box>
        </div>
        <app-check-box
          [frm]="conectorForm"
          formControlName="TodosUsuarios"
          label="Todos Usuarios"
        ></app-check-box>
        <app-check-box
          [frm]="conectorForm"
          formControlName="Activo"
          label="Activo"
        ></app-check-box>
      </div>
      <app-form-buttons
        [botonProcesando]="botonProcesando"
        buttonCancelId="btnCancel"
        labelCancel="Cancelar"
        buttonSaveId="btnCreateEdit"
        labelSave="Crear"
        [labelLoading]="textoBotonProcesando"
        [frm]="conectorForm"
        (cancel)="clearFormConector()"
        [validate]="true"
      >
      </app-form-buttons>
    </form>
  </div>
</div>

<!-- Modal Almacenado -->
<div class="docs-DialogExample-lgHeader success">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-succes" appPreventOutsideClick> 
    <div class="ms-Dialog-title">Conector Almacenado Correctamente</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Se ha almacenado el Conector.</p>
    </div>
    <div class="ms-Dialog-actions">
      <button
        class="ms-Button ms-Dialog-action ms-Button--primary"
        (click)="cerrarModal()"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
    </div>
  </div>
</div>

<!-- Modal Duplicado -->
<div class="docs-DialogExample-lgHeader duplicado">
  <div class="ms-Dialog ms-Dialog--lgHeader duplicado-succes" >
    <div class="ms-Dialog-title">Conector Duplicado Correctamente</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Se ha duplicado el Conector quedando este con el nombre {{ conectorDuplicado }}.</p>
    </div>
    <div class="ms-Dialog-actions">
      <button type="button" class="ms-Button ms-Dialog-action">Aceptar</button>
    </div>
  </div>
</div>

<!-- Modal Duplicar -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-duplicar" appPreventOutsideClick>
    <div class="ms-Dialog-title">¿Desea duplicar el conector?</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Duplicar Conector</p>
    </div>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>
      <button class="ms-Button ms-Button--primary" (click)="duplicarConector()">
        <span class="ms-Button-label">Aceptar</span>
      </button>
      <div class="ms-Spinner" [hidden]="!botonProcesando">
        <div class="ms-Spinner-label">
          {{ textoBotonProcesando }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Importar/Exportar -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-Importar" appPreventOutsideClick>
    <div class="ms-Dialog-title" *ngIf="auxImport">¿Desea importar el conector?</div>
    <div class="ms-Dialog-title" *ngIf="!auxImport">¿Desea exportar el conector?</div>
    <div class="ms-Dialog-content">
      <div *ngIf="auxImport">
        <p class="ms-Dialog-subText" *ngIf="isEmpty == 'true'">El conector está vacio, ¿desea importar un Conector?</p>
        <p class="ms-Dialog-subText" *ngIf="isEmpty == 'false'">El conector ya tiene una configuracion previa, ¿está seguro de importar un nuevo Conector?</p>
      </div>
      <p class="ms-Dialog-subText" *ngIf="!auxImport">Exportar Conector</p>
    </div>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>
      <button class="ms-Button ms-Button--primary" *ngIf="auxImport" (click)="importarConector()">
        <span class="ms-Button-label">Aceptar</span>
      </button>
      <button class="ms-Button ms-Button--primary" *ngIf="!auxImport" (click)="exportarConector()">
        <span class="ms-Button-label">Aceptar</span>
      </button>
      <div class="ms-Spinner" [hidden]="!botonProcesando">
        <div class="ms-Spinner-label">
          {{ textoBotonProcesando }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Importado -->
<div class="docs-DialogExample-lgHeader importado-s">
  <div class="ms-Dialog ms-Dialog--lgHeader importado-succes">
    <div class="ms-Dialog-title">Conector importado Correctamente</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Se ha importado el Conector.</p>
    </div>
    <div class="ms-Dialog-actions">
      <button type="button" class="ms-Button ms-Dialog-action">Aceptar</button>
    </div>
  </div>
</div>

<app-modal-notify #crearModal></app-modal-notify>

<!-- Modal para Ver Diagrama del Conector -->
<app-generic-modal
  [isVisible]="modalDiagramaVisible"
  [title]="'Conector '+ idConectorTitle + ' - '+ NombreConectorTitle"
  [showLoading]="!mostrarDiagrama"
  loadingMessage="Cargando diagrama..."
  showActionButton="true"
  actionButtonIcon="ms-Icon--Download"
  (actionButtonClick)="downloadConectorPDF()"
  (closeModal)="cerrarModalDiagrama()">
  <app-diagram-viewer 
    *ngIf="mostrarDiagrama"
    [xmlContent]="xmlContent"
    [readOnly]="true"
    [showTooltips]="false"
    [showLegend]="false"
    [hideWatermark]="true">
  </app-diagram-viewer>
</app-generic-modal>

<!-- Modal para Configuración InOut -->
<app-generic-modal
  [isVisible]="modalConfiguracionInOutVisible"
  title="Configuración de Variables In/Out"
  [showLoading]="false"
  (closeModal)="cerrarModalConfiguracionInOut()">
  <div class="configuracion-inout-content">
    <!-- Sección de Variables de Entrada -->
    <div class="seccion-variables">
      <h3 class="seccion-titulo">
        <i class="ms-Icon ms-Icon--Download"></i>
        Variables de Entrada
      </h3>
      <p class="campo-info">
        <i class="ms-Icon ms-Icon--Info"></i>
        Solo se permiten letras (a-z, A-Z), números (0-9) y guion bajo (_). No se permiten espacios ni caracteres especiales.
      </p>
      <div class="variables-container">
        <div class="variable-item" *ngFor="let variable of variablesEntrada; let i = index; trackBy: trackByIndex">
          <div class="ms-TextField">
            <label class="ms-Label">Nombre de la variable {{ i + 1 }}</label>
            <input 
              type="text" 
              class="ms-TextField-field" 
              [value]="variablesEntrada[i]"
              (input)="validarNombreVariable($event, i, 'entrada')"
              placeholder="Ingrese el nombre de la variable">
          </div>
          <button 
            type="button" 
            class="ms-Button btn-eliminar" 
            (click)="eliminarVariableEntrada(i)"
            [disabled]="variablesEntrada.length === 1"
            title="Eliminar variable">
            <i class="ms-Icon ms-Icon--Delete"></i>
          </button>
        </div>
        <button 
          type="button" 
          class="ms-Button ms-Button--primary btn-agregar" 
          (click)="agregarVariableEntrada()">
          <i class="ms-Icon ms-Icon--Add"></i>
          <span class="ms-Button-label">Agregar Variable de Entrada</span>
        </button>
      </div>
    </div>

    <!-- Sección de Variables de Salida -->
    <div class="seccion-variables">
      <h3 class="seccion-titulo">
        <i class="ms-Icon ms-Icon--Upload"></i>
        Variables de Salida
      </h3>
      <p class="campo-info">
        <i class="ms-Icon ms-Icon--Info"></i>
        Solo se permiten letras (a-z, A-Z), números (0-9) y guion bajo (_). No se permiten espacios ni caracteres especiales.
      </p>
      <div class="variables-container">
        <div class="variable-item" *ngFor="let variable of variablesSalida; let i = index; trackBy: trackByIndex">
          <div class="ms-TextField">
            <label class="ms-Label">Nombre de la variable {{ i + 1 }}</label>
            <input 
              type="text" 
              class="ms-TextField-field" 
              [value]="variablesSalida[i]"
              (input)="validarNombreVariable($event, i, 'salida')"
              placeholder="Ingrese el nombre de la variable">
          </div>
          <button 
            type="button" 
            class="ms-Button btn-eliminar" 
            (click)="eliminarVariableSalida(i)"
            [disabled]="variablesSalida.length === 1"
            title="Eliminar variable">
            <i class="ms-Icon ms-Icon--Delete"></i>
          </button>
        </div>
        <button 
          type="button" 
          class="ms-Button ms-Button--primary btn-agregar" 
          (click)="agregarVariableSalida()">
          <i class="ms-Icon ms-Icon--Add"></i>
          <span class="ms-Button-label">Agregar Variable de Salida</span>
        </button>
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="modal-actions">
      <div class="validation-message" *ngIf="!isConfiguracionInOutValida()">
        <i class="ms-Icon ms-Icon--Info"></i>
        <span>Debe configurar al menos una variable de entrada y una de salida para guardar.</span>
      </div>
      <div class="action-buttons">
        <button 
          type="button" 
          class="ms-Button" 
          (click)="limpiarConfiguracionInOut()"
          [disabled]="botonProcesandoInOut">
          <i class="ms-Icon ms-Icon--Clear"></i>
          <span class="ms-Button-label">Limpiar</span>
        </button>
        <button 
          type="button" 
          class="ms-Button ms-Button--primary" 
          (click)="guardarConfiguracionInOut()"
          [disabled]="botonProcesandoInOut || !isConfiguracionInOutValida()">
          <i class="ms-Icon ms-Icon--Save" *ngIf="!botonProcesandoInOut"></i>
          <span class="ms-Spinner" *ngIf="botonProcesandoInOut" style="width: 16px; height: 16px;"></span>
          <span class="ms-Button-label">{{ botonProcesandoInOut ? 'Guardando...' : 'Guardar' }}</span>
        </button>
      </div>
    </div>
  </div>
</app-generic-modal>
